import { formatName } from "../../../../utils/format-name.ts";
import type { EmployeePersonalDetail } from "../../../../schemas/employee-profile.schema.ts";
import type { OffboardingEmployeeDisplay } from "./use-offboarding-employee-display.ts";

export function mapPersonalDetailToOffboardingDisplay(
    personal: EmployeePersonalDetail,
): OffboardingEmployeeDisplay {
    return {
        name: formatName(personal.empName),
        empType: personal.employeeSubType ?? personal.employeeType ?? "—",
        designation: personal.designation ?? "—",
        employeeId: String(personal.id),
        email: personal.ccEmail ?? "—",
        department: personal.department ?? "—",
        manager: personal.managerName ? formatName(personal.managerName) : "—",
        photoPath: personal.photoPath,
    };
}
